<!--基于v-charts和echarts的折线图-->
<template>
  <div class="chart">
    <ve-line
      height="100%"
      :data="chartData"
      :settings="chartSettings"
      :extend="chartExtends"
      :loading="loading"
      :data-empty="data.length? false: true"
    />
  </div>
</template>
<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => { return [] }
    },
    data: {
      type: Array,
      default: () => { return [] }
    },
    setting: {
      type: Object,
      default: () => { return {} }
    },
    extend: {
      type: Object,
      default: () => { return {} }
    },
    loading: Boolean,
    unit: {
      type: String,
      default: ''
    },
    format: {
      type: Array,
      default () {
        return ['yyyy-MM-dd hh:mm']
      }
    }
  },
  data () {
    return {
      chartData: {
        columns: this.columns,
        rows: this.data
      }
    }
  },
  computed: {
    chartSettings () {
      return this.setting
    },
    chartExtends () {
      /**
       * 此处配置参考echart的配置项
      */
      const _this = this
      const extend = this.extend || {}
      const o = {
        grid: {
          left: 50,
          right: 50
        },
        xAxis: {
          axisLabel: {
            formatter: (value) => {
              return _this.$parseTime(value, this.format[0])
            }
          }
        },
        yAxis: {

        },
        tooltip: {
          formatter: (params) => {
            let html = ''
            html += _this.$parseTime(params[0].name, this.format[0])
            for (let i = 0; i < params.length; i++) {
              html += `<div>
                        ${params[i].marker} 
                        ${params[i].seriesName}: ${params[i].data[1] + this.unit}  
                    </div>`
            }
            return html
          }
        }
      }
      Object.assign(o, extend)
      return o
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.chartData.rows = val
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
    columns (val) {
      this.chartData.columns = val
    }
  }
}
</script>
<style lang="stylus" scoped>
.chart
  height 100%
  width 100%
/deep/.v-charts-data-empty
  background-color: #1C2550
  color #1cc197
  font-size 16px
</style>
